module.exports = __webpack_public_path__ + "assets/icon-envelop-blue.svg";